// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"736":"8ce0cca6","2243":"3fcffa73","5617":"1d74b8fc","7255":"f06fc859","8114":"8f7e778d"}[chunkId] + ".chunk.css";
};